import {
    SET_WEEK_COUNT,
    SET_WEEK_START,
    GET_EVENT_ROWS,
    GET_USERS,
    GET_TEMPLATE,
    SET_USER_POSITIONS,
    SET_TEMP_USER_POSITIONS,
    GET_JOBPACKS
} from "./types";
import moment from "moment";

const INITIAL_STATE = {
    weekCount: 1,
    weekStart: moment()
        .startOf("isoWeek")
        .toDate(),
    eventRows: false,
    eventRowsRequesting: false,
    users: false,
    usersRequesting: false,
    template: false,
    templateRequesting: false,
    userPositions: false,
    tempUserPositions: false,
    jobpacks: false,
    jobpacksRequesting: false
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SET_USER_POSITIONS: {
            return {
                ...state,
                userPositions: action.payload,
                tempUserPositions: action.payload
            };
        }
        case SET_TEMP_USER_POSITIONS: {
            return {
                ...state,
                tempUserPositions: action.payload
            };
        }
        case SET_WEEK_COUNT: {
            return { ...state, weekCount: action.payload };
        }
        case SET_WEEK_START: {
            return { ...state, weekStart: action.payload };
        }
        case GET_EVENT_ROWS.REQUEST: {
            return { ...state, eventRowsRequesting: true };
        }
        case GET_EVENT_ROWS.FAIL: {
            return { ...state, eventRows: false, eventRowsRequesting: false };
        }
        case GET_EVENT_ROWS.SUCCESS: {
            return {
                ...state,
                eventRows: action.payload,
                eventRowsRequesting: false
            };
        }
        case GET_JOBPACKS.REQUEST: {
            return { ...state, jobpacksRequesting: true };
        }
        case GET_JOBPACKS.FAIL: {
            return { ...state, jobpacks: false, jobpacksRequesting: false };
        }
        case GET_JOBPACKS.SUCCESS: {
            return {
                ...state,
                jobpacks: action.payload,
                jobpacksRequesting: false
            };
        }
        case GET_USERS.REQUEST: {
            return { ...state, usersRequesting: true };
        }
        case GET_USERS.FAIL: {
            return { ...state, users: false, usersRequesting: false };
        }
        case GET_USERS.SUCCESS: {
            return {
                ...state,
                users: action.payload,
                usersRequesting: false
            };
        }
        case GET_TEMPLATE.REQUEST: {
            return { ...state, templateRequesting: true };
        }
        case GET_TEMPLATE.FAIL: {
            return { ...state, template: false, templateRequesting: false };
        }
        case GET_TEMPLATE.SUCCESS: {
            return {
                ...state,
                template: action.payload,
                templateRequesting: false
            };
        }
        default: {
            return state;
        }
    }
};
